<script setup>
import AuthService from '@/services/AuthService'
import AuthLayout from '@/views/AuthLayout.vue';
import { reactive, ref } from 'vue';
import { useRouter } from 'vue-router';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { useToast } from "primevue/usetoast";

const route = useRoute();
const router = useRouter();
const toast = useToast();

const form = reactive({
    password: '',
    confirmPassword: ''
});
const isLoading = ref(false)

const errors = reactive({
    password: null,
    confirmPassword: null,
});


const validateForm = () => {
    errors.password = form.password.length >= 5 ? null : 'Password must be at least 3 characters long.';
    errors.confirmPassword = form.confirmPassword !== form.password ? 'Passwords do not match' : null;
    return !errors.password && !errors.confirmPassword;
};

const changePassword = async () => {
    isLoading.value = true;

    try {
        if (validateForm()) {
            const token = route.params.token;
            await AuthService.resetPassword(token, form.password);
            toast.add({
                severity: 'success',
                summary: 'Password Successfully changed',
                detail: 'Redirecting to login to enter your fresh password.',
                life: 5000
            });
            setTimeout(() => {
                router.push({ name: 'Login' });
            }, 3000);
        }
    } catch (err) {
        console.error('Error:', err);
    } finally {
        isLoading.value = false;
    }
};
</script>

<template>
    <AuthLayout>
        <div class="flex h-screen">
            <Toast />
            <!-- Left Section: Image -->
            <div class="hidden lg:block lg:w-2/3">
                <img src="@/assets/left-side.jpg" alt="Welcome Image"
                    class="h-full w-full object-cover object-center" />
            </div>

            <!-- Right Section: Login Form -->
            <div class="flex justify-center items-center w-full lg:w-1/3 logged-out-container px-4 sm:px-8">
                <!-- Background Image Container -->
                <div class="absolute inset-0 w-full h-full">
                    <img src="@/assets/right-side-background.png" alt="" class="w-full h-full object-cover "
                        loading="lazy" />
                </div>
                <div class="flex flex-col justify-start items-center w-full max-w-md relative -mt-10">
                    <h1 class="text-xl pb-10">Time to change your password!</h1>
                    <div class="bg-[var(--secondary-background-color)] p-8 rounded-lg w-full max-w-sm">
                        <div id="password-section-login" class="flex flex-col ">
                            <label for="password" class="text-left w-full text-white">New password</label>
                            <div class="mt-1 w-full">
                                <Password id="password" v-model="form.password" name="password" placeholder="Password"
                                    required toggleMask :feedback="false" class="w-full max-w-full " fluid />
                            </div>
                            <small class="error text-left w-full text-red-500 mt-1" v-if="errors.password">{{
                                errors.password }}</small>
                        </div>
                        <div id="confirm-password-section-login" class="flex flex-col mt-10">
                            <label for="password" class="text-left w-full text-white">Confirm new password</label>
                            <div class="mt-1 w-full">
                                <Password id="password" v-model="form.confirmPassword" name="password"
                                    placeholder="Confirm password" required toggleMask :feedback="false"
                                    class="w-full max-w-full " fluid />
                            </div>
                            <small class="error text-left w-full text-red-500 mt-1" v-if="errors.confirmPassword">{{
                                errors.confirmPassword }}</small>
                        </div>

                        <div class="mt-10 w-full max-w-sm">
                            <Button :loading="isLoading" @click="changePassword" severity="primary">
                                <span class="font-bolyar">
                                    <span class="larger-letter">C</span><span>hange Password</span>
                                </span>
                                <img src="@/assets/icons/login-icon.svg" alt="" class="w-5 h-5 ml-2" />
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </AuthLayout>
</template>

<style scoped>
.p-field {
    margin-bottom: 1em;
}
</style>